import React from "react"

export const MenuIcon = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      width={24 * size}
      height={24 * size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <g stroke={color} strokeWidth="3">
          <path d="M0 5.5h3M0 11.5h3M0 17.5h3M6 5.5h18M6 11.5h18M6 17.5h18" />
        </g>
      </g>
    </svg>
  )
}
